<script>import { onMount } from "svelte";
import { getTranslation } from "./stores";
import { translateElement } from "./utils";
export let id;
export let args = void 0;
let root;
let translatedRoot;
$:
  translation = $getTranslation(id, args);
$:
  update(translation);
function update(t) {
  if (t && root) {
    const newRoot = root.cloneNode(true);
    translateElement(newRoot, t);
    if (translatedRoot?.parentNode) {
      translatedRoot.parentNode.replaceChild(newRoot, translatedRoot);
    }
    translatedRoot = newRoot;
  }
}
onMount(() => {
  const observer = new MutationObserver(() => {
    update(translation);
  });
  if (root && translation) {
    translatedRoot = root.cloneNode(true);
    translateElement(translatedRoot, translation);
    if (root?.parentNode) {
      root.parentNode.replaceChild(translatedRoot, root);
    }
    observer.observe(root, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
  }
  return () => {
    observer.disconnect();
    if (translatedRoot?.parentNode) {
      translatedRoot.parentNode.replaceChild(root, translatedRoot);
    }
  };
});
</script>

<div bind:this={root}>
	<slot />
</div>

<style>
	div {
		display: contents;
	}
</style>
